export const getMultilingualQueryParam = (multilingual) => {
    if (multilingual === null || multilingual === void 0 ? void 0 : multilingual.currentLanguage) {
        const locale = multilingual.siteLanguages.find((lang) => lang.languageCode === multilingual.currentLanguage);
        if (!locale.isPrimaryLanguage && locale.resolutionMethod === 'QueryParam') {
            return `?lang=${locale.languageCode}`;
        }
    }
    return '';
};
//# sourceMappingURL=get-multilingual-query-param.js.map